export const pluralize = ({ count, word }) => {
  if (count === 1) {
    return `${count} ${word}`;
  }

  return `${count} ${word}s`;
};
